import { memo } from 'react';
import classNames from 'classnames';
import NTCell from '../NTCell';
import { prefixClass } from 'lib/utils';

interface NTDrawColumnProps {
  title?: string | null;
  columnIndex?: number;
  columnData?: any[];
  liveColumn?: boolean;
  fixed?: boolean;
  totalColumn?: boolean;
  compoundColumn?: boolean;
  isDifferenceColumn?: boolean;
}

const NTDrawColumn = memo<NTDrawColumnProps>(
  ({
    columnIndex,
    columnData,
    liveColumn,
    fixed = false,
    totalColumn = false,
    compoundColumn = false,
    isDifferenceColumn = false,
  }) => {
    const prefix = prefixClass('nt-layout-column');

    // TEMP: Debug rendering (enable to track column re-renders)
    // if (process.env.NODE_ENV === 'development') {
    //   console.log('[NTDrawColumn render]', columnIndex);
    // }

    return (
      <div
        className={classNames(prefix(), {
          fixed: fixed,
          'first-column': columnIndex === 0,
          compound: compoundColumn,
          live: liveColumn,
          'difference-column': isDifferenceColumn,
        })}
      >
        {columnData?.map((item: any, itemIndex: number) => (
          <NTCell
            key={`${item.id || itemIndex}_${itemIndex}`}
            cellData={item}
            cellID={item.cellID}
            liveColumn={liveColumn}
            rowID={item.id}
            allColumn={columnData}
            totalColumn={totalColumn}
            columnIndex={columnIndex}
          />
        ))}
      </div>
    );
  },
  // Custom equality check - prevent re-renders if props haven't actually changed
  (prevProps, nextProps) => {
    return (
      prevProps.columnIndex === nextProps.columnIndex &&
      prevProps.title === nextProps.title &&
      prevProps.liveColumn === nextProps.liveColumn &&
      prevProps.fixed === nextProps.fixed &&
      prevProps.totalColumn === nextProps.totalColumn &&
      prevProps.compoundColumn === nextProps.compoundColumn &&
      prevProps.isDifferenceColumn === nextProps.isDifferenceColumn &&
      prevProps.columnData === nextProps.columnData
    );
  }
);

NTDrawColumn.displayName = 'NTDrawColumn';

export default NTDrawColumn;
